import { render, staticRenderFns } from "./EventDetailsForm.vue?vue&type=template&id=dfabe152&scoped=true"
import script from "./EventDetailsForm.vue?vue&type=script&lang=ts"
export * from "./EventDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./EventDetailsForm.vue?vue&type=style&index=0&id=dfabe152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfabe152",
  null
  
)

export default component.exports